import React, { useState, useEffect } from 'react';

const CookieBar = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const v = localStorage.getItem('tm_cookie');
    if (!v) setShow(true);
  }, []);

  const set = (val) => {
    localStorage.setItem('tm_cookie', val);
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 shadow-lg">
      <div className="max-w-[1280px] mx-auto px-5 lg:px-8 py-3 flex flex-col sm:flex-row items-center justify-center gap-3 text-sm">
        <p className="text-gray-700">
          We use cookies to improve your experience. By continuing, you agree to our{' '}
          <a href="#" className="text-[#0d64a8] underline">Privacy Policy</a>.
        </p>
        <div className="flex gap-2">
          <button onClick={() => set('accepted')} className="bg-[#ffcc29] hover:bg-[#e6b81f] text-[#0a2a4a] font-medium px-4 py-1.5 rounded transition text-xs">Accept</button>
          <button onClick={() => set('declined')} className="bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium px-4 py-1.5 rounded transition text-xs">Decline</button>
        </div>
      </div>
    </div>
  );
};

export default CookieBar;
